import { render, staticRenderFns } from "./ifromD.vue?vue&type=template&id=f6a6729c&scoped=true&"
import script from "./ifromD.vue?vue&type=script&lang=js&"
export * from "./ifromD.vue?vue&type=script&lang=js&"
import style0 from "./ifromD.vue?vue&type=style&index=0&id=f6a6729c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a6729c",
  null
  
)

export default component.exports